import { render, staticRenderFns } from "./SpecReady.vue?vue&type=template&id=1dd8be16"
var script = {}
import style0 from "./SpecReady.vue?vue&type=style&index=0&id=1dd8be16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports